// atoms
export { default as Image } from './atoms/image';
export { default as ImageBox } from './atoms/imageBox/index';
export { default as VideoBox } from './atoms/videoBox/index';
export { default as TextBox } from './atoms/textBox/index';
export { default as NoticeBar } from './atoms/NoticeBar'
// molecules
// export { default as Swiper } from './molecules/swiper';
// export { default as Tabs } from './molecules/tabs';

export { default as AnchorTabs } from './molecules/anchorTabs/index';
export { default as DownloadBar } from './molecules/downloadBar/index';
export { default as CustomTitle } from './molecules/customTitles/index';
export { default as SearchBar } from './molecules/searchBar/index';

// organisms
// export { default as Banner } from './organisms/banner';

export { default as ProductList } from './organisms/productList/index';
export { default as MixedBlocks } from './organisms/mixedBlocks/index';
export { default as CombinationList } from './organisms/combinationList'
export { default as Block } from './organisms/block'


export { default as Conference } from './organisms/conference/index' // 特殊业务组件，引入所有的其他类型组件

export { I18nextProvider } from './i18n'